import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { AbilitiesSelectors } from '@core/abilities-data';
import { Ability } from '@core/abilities-types';

@Injectable({ providedIn: 'root' })
export class StatusesDropdownContainerDataService {
  private readonly store = inject(Store);

  public canManageJobs = this.store.selectSignal(AbilitiesSelectors.hasOne(Ability.ManageJobs));
  public hasPublishJobs = this.store.selectSignal(AbilitiesSelectors.hasOne(Ability.PublishJobs));
}
